<template>
    <div class="ga-page">
        <h1>Google Analytics</h1>
        <button id="auth-button" hidden @click="autorize">Authorize</button>
        <button @click="loadData">LoadData</button>

    </div>
</template>


<script>
    import * as GA from '../../servises/googleAnalytics'

  export default {
    name: 'GoogleAnalitycs',
    data () {
      return {}
    },
    created(){},
    methods:{
      autorize(){
       // GA.authorize()
      },
      loadData(){
       // GA.queryReports()
      }
    }
  }
</script>

<style scoped>

</style>
